jQuery(document).ready(function($) {
    $(window).on('scroll', function() {
        if ($(window).scrollTop() > 50) {
            $('header .navbar').addClass('scrolled');
        } else {
            $('header .navbar').removeClass('scrolled');
        }
    });
    var $msContainers = jQuery('.ms-container');

    $msContainers.each(function() {
        var $msContainer = jQuery(this);

        $msContainer.imagesLoaded(function() {
            $msContainer.masonry({
                itemSelector: '.ms-item',
                percentPosition: true
            });
        });
    });
});

$(document).ready(function () {
  if ($('.masonry-row').length > 0) {
    var $grid = $('.masonry-row').masonry({
      itemSelector: '.masonry-col',
      percentPosition: true
    });
  }
});